import React, {  useEffect, useState  } from "react";
import { useParams, Link  } from 'react-router-dom';
import helpers from '../_helpers/helpersFunction';
const config = require("../_helpers/configServizi"); 

 
export default function Terms(props) {
    
	let params = useParams();
	const [testo, setTesto] = useState("");

	
    const country = helpers.getCountry("0000")
    const browserLanguage = navigator.language.slice(0, 2);
    const finalCountry = country === browserLanguage ? country : "en";


	const domain = window.location.hostname;
	const url_logo = config.servizi[domain].logo_su_scuro;

    useEffect(() => {
        const domain = window.location.hostname;
		const token = localStorage.getItem('token');
		if(params.page === "faq" || params.page === "cookie" || params.page === "privacy" || params.page === "terms" ||  params.page === "features" || props.pagina === "faq" || props.pagina === "cookie" || props.pagina === "privacy" || props.pagina === "terms" || props.pagina === "features"){

			var pagina = params.page ? params.page : props.pagina
			
			fetch(process.env.REACT_APP_APIADDRESS+"/legal", {
				method: 'POST',
				headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer '+ token
				},
				body: JSON.stringify({"p" : pagina, "d" :domain, "l":finalCountry })
			})
			.then(response => response.text()) 
			.then(data => {
				setTesto(data)
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			});
		}
		
	},[params.page,props.pagina]); 
       
    return (
	<>
			<nav>
                    <div className="navbar navbar-default navbar-fixed-top" role="navigation">
                        <div className="container">
                                <div className="navbar-header">
                                    <Link className="navbar-brand" to="/"><img src={url_logo} className="img-fluid" /></Link>
                                </div>
                               

                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                            </div>
                        </div>
                    </div>
                </nav>
				<nav className="navbar navbar-expand-lg navbar-light fixed-top d-none d-lg-block ">
                    <div className="container navbar-desktop">
                        <Link className="navbar-brand" to="/"><img src={url_logo} className="img-fluid" /></Link>
                        <div className="navbar-collapse" id="navbarSupportedContent">
                    
                        
                        </div>{}
                    </div>
                </nav>
	<div className="all-container bg-light legal-page">
        <div className="container filters-no-padding" role="main">
           
            <div style={{marginTop:"90px"}} className="row">
                    <div className="col-md-7 col-12 col-centered">
                      
						<div dangerouslySetInnerHTML={{__html: testo}} />

                    </div>
            </div>
        </div>
    </div>
      </>      )

}